import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import LoginForm from '../../components/auth/LoginForm';
import authService from '../../services/authService';

const { __environment__ } = window as any;

const redirectURL = __environment__.REACT_APP_MOLINA_APP_URL;

const PREFIX = 'Login';

const classes = {
  container: `${PREFIX}-container`,
  content: `${PREFIX}-content`,
  left: `${PREFIX}-left`,
  right: `${PREFIX}-right`,
  center: `${PREFIX}-center`,
  logo1: `${PREFIX}-logo1`,
  logo2: `${PREFIX}-logo2`,
  logo3: `${PREFIX}-logo3`,
  logo4: `${PREFIX}-logo4`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'row',
    flex: '0 1 100%',
    backgroundColor: theme.palette.info,
    width: '100%',
    minHeight: '100%',
    backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: 'url(/background_small.png)',
    },
    [theme.breakpoints.up('sm')]: {
      backgroundImage: 'url(/background.png)',
    },
  },

  [`& .${classes.left}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    marginBottom: 'auto',
    marginRight: 65,
    alignItems: 'end',
  },

  [`& .${classes.right}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    marginBottom: 'auto',
    marginLeft: 65,
    alignItems: 'left',
  },

  [`& .${classes.center}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    marginBottom: 'auto',
    alignItems: 'center',
  },

  [`& .${classes.logo1}`]: {
    width: 400,
    marginBottom: 19,
  },

  [`& .${classes.logo2}`]: {
    width: 230,
    marginTop: 18,
    marginRight: 85,
  },

  [`& .${classes.logo3}`]: {
    width: 163,
    marginBottom: 19,
    [theme.breakpoints.down('lg')]: {
      marginTop: 50,
      marginBottom: 30,
    },
  },

  [`& .${classes.logo4}`]: {
    width: 137,
    marginTop: 18,
  },
}));

export default function Login() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up('md'));
  const [searchParams] = useSearchParams();
  const [loginError, setLoginError] = React.useState<string>('');
  const [returnPage, setReturnPage] = React.useState<string>('/');

  React.useEffect(() => {
    const page = searchParams.get('returnPage');
    if (page) {
      setReturnPage(page);
    }
  }, []);

  const login = (info: any) => {
    authService
      .login(info.Email, info.Password)
      .then((tokens) => {
        if (tokens) {
          const url = `${redirectURL}/auth?accesstoken=${tokens?.accessToken}`;
          window.location.href = url;
        } else {
          navigate('/resetPassword');
        }
      })
      .catch((err) => {
        setLoginError(t('auth.invalid') || '');
      });
  };

  return (
    <Root className={classes.container}>
      {isLarge && (
        <Box className={classes.left}>
          <img alt="Molina" src="/logo.png" className={classes.logo1} />
        </Box>
      )}
      {isLarge && (
        <Box className={classes.right}>
          <LoginForm
            returnPage={returnPage}
            submit={login}
            error={loginError}
          />
        </Box>
      )}
      {!isLarge && (
        <Box className={classes.center}>
          <img alt="Molina" src="/logo.png" className={classes.logo3} />
          <LoginForm
            returnPage={returnPage}
            submit={login}
            error={loginError}
          />
        </Box>
      )}
    </Root>
  );
}
